import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { get_schedule_api_status } from '../../redux/app/app.selectors';
import { App_Service } from '../../redux/app/app.services';
import LinearWithValueLabel from '../../common/components/ProgressBar/LinearProgressWithLabel';

const LoadingScreen = () => {
  const { download_progress: { progress: download_progress }, upload_progress: { progress: upload_progress } } = useSelector(get_schedule_api_status);

  const [progress, set_progress] = useState(0);

  const api_interval = useRef(null);

  useEffect(() => {
    if (api_interval.current) {
      clearInterval(api_interval.current);
    }
    api_interval.current = setInterval(() => {
      try {
        App_Service.schedule_progress_dummy().then((response) => {
          const data = response.data;
          const { progress } = data;
          set_progress(progress);
        }).catch((reason) => {
          console.log("error occured during the fetching of schedule progress...");
          console.log({ reason });
        });
      } catch (error) {
        console.log("error occured while trying to get schedule progress...");
      }
    }, 2000);

    return () => {
      if (api_interval.current) {
        console.log("cleanup");
        clearInterval(api_interval.current);
      }
    };
  }, []);

  useEffect(() => {
    console.log({ download_progress });
  }, [download_progress]);


  return (
    <Box className="h-[70%] flex items-center justify-center flex-col">
      <img src="/optimus.png" alt="optimus at work" />
      <Box>
        <p className="text-4xl">Optimus at work...</p>
        <Box className="text-blue-400 bg-black p-4 py-6 my-2 rounded">
          {
            upload_progress > 0 &&
            <>
              <p>Uploading Data</p>
              <LinearWithValueLabel value={upload_progress} />
            </>
          }
          <p className='my-4'>Scheduler Progress : {download_progress > 0 ? 100 : progress}%</p>
          {
            download_progress > 0 &&
            <>
              <p>Downloading Data</p>
              <LinearWithValueLabel value={download_progress} />
            </>
          }
        </Box>
      </Box>
    </Box >
  );
};

export default LoadingScreen;